import React from 'react';
import { useParams } from 'react-router-dom';
import { CartProvider } from '../contexts/CartContext';

/**
 * Wraps QR menu route children with CartProvider scoped to current restaurantId + (optional) tableNumber.
 * - Without table: shared cart for the restaurant (legacy behavior)
 * - With table (URL pattern /qr-menu/:rid/t/:tableNumber): cart scoped to that table
 */
export const QRRouteWrapper = ({ children }) => {
  const { restaurantId, tableNumber } = useParams();
  const tableNum = tableNumber ? parseInt(tableNumber, 10) : null;
  return (
    <CartProvider restaurantId={restaurantId} tableNumber={tableNum}>
      {children}
    </CartProvider>
  );
};
